module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraLight.woff?7d759358c1372fa6acae4cb22f93defa";